module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/solution1_2-d4b1b46bb8bc86cb54521e9135c84bb8.png";